class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.overlay = this.querySelector('[data-cart-notification-overlay]');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay?.addEventListener('click', this.close.bind(this));
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.overlay?.classList.add('active');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.overlay?.classList.remove('active');
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

	renderContents(parsedState, { open = true } = {}) {
		if (!parsedState || !parsedState.key || !parsedState.sections) return;

		this.cartItemKey = parsedState.key;
		const cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			if (typeof parsedState.item_count === 'number') {
				cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
			} else {
				// /cart/add responses on mobile may not include item_count.
				// Successful render means an item was added, so keep drawer out of empty state.
				cartDrawer.classList.remove('is-empty');
			}
		}

		const sectionsToRender = this.getSectionsToRender?.();
		if (Array.isArray(sectionsToRender)) {
			sectionsToRender.forEach((section) => {
				const sectionHTML = parsedState.sections[section.id];
			const targetElement = section.id === 'cart-notification-product'
				? document.getElementById(section.id)
				: section.selector
					? document.querySelector(section.selector)
					: document.getElementById(section.id);

				if (sectionHTML && targetElement) {
					targetElement.innerHTML = this.getSectionInnerHTML?.(sectionHTML, section.selector) || '';
				}
			});
		}

		// Mobile quick-add refreshes the drawer markup through the notification,
		// so re-apply its policy-checkbox state after that replacement.
		cartDrawer?.syncPolicyCheckoutState?.();

		if (open) {
			if (this.header?.reveal) this.header.reveal();
			if (this.open) this.open();
		}
	}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-bubble-sticky',
        selector: '#cart-icon-bubble-sticky',
      },
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
